import React from 'react';
import { IconButtonLinkProps } from './types';
import { StyledIconButtonLink } from './styles';

const IconButtonLink: React.FC<IconButtonLinkProps> = ({
  icon: Icon,
  isActive,
  isSecondary,
  ...props
}) => (
  <StyledIconButtonLink {...{ isActive, isSecondary, ...props }}>
    <Icon />
  </StyledIconButtonLink>
);

export default IconButtonLink;
